/**
 * Site Refresh 2026: product card "Framed" (A4). Desktop hover only:
 * the photo swaps to image 2 and thin scrub bars appear; moving the pointer across
 * the photo shows that image (max 5, no autoplay). Images load on the first hover.
 * Delegated on document, so cards added later (filters, recently viewed) work too.
 */
(() => {
	const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
	const cache = new WeakMap();

	function setup(media) {
		if (cache.has(media)) return cache.get(media);
		let urls = [];
		try { urls = JSON.parse(media.getAttribute('data-rc-images') || '[]'); } catch (e) { urls = []; }
		if (urls.length < 2) { cache.set(media, null); return null; }
		const img = document.createElement('img');
		img.className = 'rc-card__img rc-card__img--hover';
		img.alt = '';
		img.setAttribute('aria-hidden', 'true');
		img.decoding = 'async';
		img.addEventListener('load', () => img.classList.add('is-loaded'));
		const base = media.querySelector('.rc-card__img');
		if (base && base.nextSibling) media.insertBefore(img, base.nextSibling); else media.appendChild(img);
		urls.forEach((u) => { const p = new Image(); p.src = u; });
		const state = { urls, img, bars: [...media.querySelectorAll('.rc-card__scrub > span')], index: -1 };
		cache.set(media, state);
		return state;
	}

	function show(state, i) {
		if (state.index === i) return;
		state.index = i;
		state.img.src = state.urls[i];
		if (state.img.complete && state.img.naturalWidth) state.img.classList.add('is-loaded');
		state.bars.forEach((b, n) => b.classList.toggle('is-active', n === i));
	}

	document.addEventListener('pointerover', (e) => {
		if (!fine.matches || e.pointerType !== 'mouse') return;
		const media = e.target.closest && e.target.closest('.rc-card__media[data-rc-images]');
		if (!media || media.contains(e.relatedTarget)) return;
		const card = media.closest('.rc-card');
		const state = setup(media);
		if (!card || !state) return;
		card.classList.add('is-scrubbing');
		show(state, 1);
	});

	document.addEventListener('pointermove', (e) => {
		if (e.pointerType !== 'mouse') return;
		const media = e.target.closest && e.target.closest('.rc-card__media[data-rc-images]');
		const state = media && cache.get(media);
		if (!state) return;
		const r = media.getBoundingClientRect();
		const i = Math.max(0, Math.min(state.urls.length - 1, Math.floor(((e.clientX - r.left) / r.width) * state.urls.length)));
		show(state, i);
	}, { passive: true });

	document.addEventListener('pointerout', (e) => {
		const media = e.target.closest && e.target.closest('.rc-card__media[data-rc-images]');
		if (!media || media.contains(e.relatedTarget)) return;
		const card = media.closest('.rc-card');
		const state = cache.get(media);
		if (card) card.classList.remove('is-scrubbing');
		if (state) state.index = -1;
	});
})();
